<style src="../style/animate.css"></style>
<style scoped src="../style/live.css"></style>
<template>
	<div id="livePage">
		<div class="container">
			<!-- 左侧导航 -->
			<div class="leftNav">
				<router-link to="/">
					<span class="iconfont iconshouye"></span>
					<br>首页
				</router-link>
				<router-link to="/list?type=hot">
					<span class="iconfont iconremen"></span>
					<br>热门
				</router-link>
				<router-link to="/list?type=new">
					<span class="iconfont iconnew"></span>
					<br>最新
				</router-link>
				<router-link to="/list?type=attention" v-show="imgsrc">
					<span class="iconfont iconguanzhu"></span>
					<br>关注
				</router-link>
				<div class="loginBox" v-show="!imgsrc" @click="showLogin">
					<img src="@/assets/images/default.png">
					登录
				</div>
				<div class="infoBox">
					<img :src="imgsrc" v-show="imgsrc" @error="defaultPic($event)" class="headPic">
                	<logincard class="userCard"></logincard>
					<div class="exit" v-show="imgsrc" @click="userExit">退出</div>
				</div>
			</div>
			<!-- 右边部分 -->
			<div class="rightBox">
				<div class="videoBox" id="videoBox">
					<div style="width:100%;height:100%">
						<livePlayBox ref="video" :previewAnchorId='previewAnchorId' :bShowEnter='false' :bEnd="close" @getAnchorInfoFinishi="mcCallBack"/>
						<div class="liveEnd" v-show="close">
							<div class="centerBox">
								<div class="title">直播已结束，看看其他直播吧</div>
								<div class="otherMc">
									<div class="mcInfo" v-if="mcInfo">
										<img :src="mcInfo.img" @error="defaultPic($event)"><br>
										{{mcInfo.name}}
										<br><button @click="onClickFollow" class="purpleBtn" v-show="!mcInfo_num.isFollow">+关注</button>
									</div>
									<div class="list borderBox" @click="onClickAnchorFinnish(hotList[0].id, hotList[0].familyid ? hotList[0].familyid : 0)" v-if="hotList[0]">
										<div class="maskBox">
											<div class="playIcon">
												<span class="iconfont iconbofang"></span>
											</div>
										</div>
										<img :src="hotList[0].img" class="coverImg">
										<p><img :src="hotList[0].img">{{hotList[0].name|code}}</p>
									</div>
									<div class="list borderBox" @click="onClickAnchorFinnish(hotList[1].id, hotList[1].familyid ? hotList[1].familyid : 0)" v-if="hotList[1]">
										<div class="maskBox">
											<div class="playIcon">
												<span class="iconfont iconbofang"></span>
											</div>
										</div>
										<img :src="hotList[1].img" class="coverImg">
										<p><img :src="hotList[1].img">{{hotList[1].name|code}}</p>
									</div>
								</div>
							</div>
						</div>
						<!-- PK血条 -->
						<div class="bloodBox" v-show="pkData.status">
							<div class="blue" :style="{width:pkData.bluePercent+'%'}"></div>
							<div class="red" :style="{width:pkData.redPercent+'%'}"></div>
							<div class="blueScore">{{linkData.active==1?'我方':'对方'}}{{pkData.blueScore}}</div>
							<div class="redScore">{{linkData.active==1?'对方':'我方'}}{{pkData.redScore}}</div>
							<div class="time">{{pkData.pkTime|pktime}}</div>
						</div>
						<div class="blueAdd">
							<div v-for="el in pkData.blueAdd">+{{el}}</div>
						</div>
						<div class="redAdd">
							<div v-for="el in pkData.redAdd">+{{el}}</div>
						</div>
						<div class="resultBox redWin" v-if="pkData.result==2&&!pkData.status">
							<img src="@/assets/images/lose.gif" class="bigGif leftPic">
							<img src="@/assets/images/lose_s.gif" class="smallGif leftPic">
							<img src="@/assets/images/win.gif" class="bigGif rightPic">
							<img src="@/assets/images/win_s.gif" class="smallGif rightPic">
						</div>
						<div class="resultBox redWin" v-if="pkData.result==1&&!pkData.status">
							<img src="@/assets/images/win.gif" class="bigGif leftPic">
							<img src="@/assets/images/win_s.gif" class="smallGif leftPic">
							<img src="@/assets/images/lose.gif" class="bigGif rightPic">
							<img src="@/assets/images/lose_s.gif" class="smallGif rightPic">
						</div>
						<!-- 连麦进房图 -->
						<img src="@/assets/images/link.gif" class="linkGif" v-if="linkData.linkPic">
						<img src="@/assets/images/pk.gif" class="linkGif" v-if="pkData.pkPic">
						<img src="@/assets/images/luckytime.gif" class="linkGif" v-if="pkData.luckyTime">
						<!-- 弹幕列表 -->
						<!-- 房间 -->
						<div class="dan1" v-for="(el,index) in dan1List" :style="{top:el.top}">
							<img :src="el.img" @error="defaultPic($event)" class="h_pic">
							<div class="userMsg">
								{{el.fname|code}}
								<div :class="'levBox lev'+el.fpl1">
									<img :src="levImg(el.fpl1,1)">
									{{el.fpl2}}
								</div>
							</div>
							<div class="word">{{el.gctent|code}}</div>
						</div>
						<!-- 全站 -->
						<div class="dan2" v-for="(el,index) in dan2List" :style="{top:el.top}">
							<img :src="el.img" @error="defaultPic($event)" class="h_pic">
							<div class="userMsg">
								{{el.fname|code}}
								<div :class="'levBox lev'+el.fpl1">
									<img :src="levImg(el.fpl1,1)">
									{{el.fpl2}}
								</div>
							</div>
							<div class="word">{{el.gctent|code}}</div>
						</div>
						<!-- 筋斗云 -->
						<div class="dan3" v-for="(el,index) in dan3List" :style="{top:el.top}">
							<img :src="el.img" @error="defaultPic($event)" class="h_pic">
							<div class="userMsg">
								{{el.fname|code}}
								<div :class="'levBox lev'+el.fpl1">
									<img :src="levImg(el.fpl1,1)">
									{{el.fpl2}}
								</div>
							</div>
							<div class="word">{{el.gctent|code}}</div>
							<img src="@/assets/images/cloud.png" class="cloud" @click="mcTab(el.aid,el.familyid)">
						</div>
						<!-- 大奖豪华飘条 -->
						<!-- <div class="zdjBox" v-for="el in dan4List" :style="'top:'+el.top">
							<div class="msg" v-html="el.content"></div>
						</div> -->
						<div class="zdjBox" v-for="(el,index) in dan5List" :style="'top:'+el.top">
							<img :src="el.img" @error="defaultPic($event)" class="h_pic">
							<div class="userMsg">
								{{el.fname|code}}
								<div :class="'levBox lev'+el.fpl1">
									<img :src="levImg(el.fpl1,1)">
									{{el.fpl2}}
								</div>
							</div>
							<div class="word" v-html="el.str"></div>
							<img :src="el.gift_image" class="g_image">
							<div class="fireBox"></div>
						</div>
						<!-- 大奖普通飘条 -->
						<div class="zxjBox" v-for="(el,index) in dan4List" :style="'top:'+el.top">
							<img :src="el.img" @error="defaultPic($event)" class="h_pic">
							<div class="userMsg">
								{{el.fname|code}}
								<div :class="'levBox lev'+el.fpl1">
									<img :src="levImg(el.fpl1,1)">
									{{el.fpl2}}
								</div>
							</div>
							<div class="word" v-html="el.str"></div>
							<img :src="el.gift_image" class="g_image">
						</div>
						<!-- 疯播号 -->
						<span class="fbNum">随风号：{{previewAnchorId}}</span>
						<div class="nowTime">{{new Date()|getCurrentTime}}</div>
						<!-- 左上角主播信息 -->
						<div class="mcMsgBox">
							<div class="clear mc_top" v-if="mcInfo">
								<img :src="mcInfo.img" @error="defaultPic($event)">
								<p :title="mcInfo.name|code">{{mcInfo.name|code}}<br>观看人数{{watchNum}}</p>
								<button v-if="!mcInfo_num.isFollow" class="purpleBtn" @click="onClickFollow">+关注</button>
								<button v-else class="purpleBtn" @click="onClickFollow">已关注</button>
							</div>
							<div class="clear mc_mid">
								<p class="left">粉丝<br>{{mcInfo_num.fans_num}}</p>
								<p class="left">风采<br>{{fengcai|toFengcai}}</p>
								<p class="left">关注<br>{{mcInfo_num.follow_num}}</p>
							</div>
							<div class="clear mc_bom">
								<div class="left" :class="'lev'+levMsg.consumebase">
									<img :src="levImg(levMsg.consumebase,1)">
									<span v-cloak>用户等级<br>{{levMsg.consumelevle}}</span>
								</div>
								<div class="right" :class="'lev'+levMsg.incomebase">
									<img :src="levImg(levMsg.incomebase,2)">
									<span>主播等级<br>{{levMsg.incomelevle}}</span>
								</div>
							</div>
						</div>
						<!-- 主播疯采榜 -->
						<div class="rankBox" v-show="false">
							<div class="rank_top">
								<div class="top1">
									<img src="@/assets/images/default.png">
									<p class="msg">我的名字呀<br><span>ID：123456789</span></p>
									<p class="expenditure">88888.59万</p>
								</div>
								<div class="top2">
									<img src="@/assets/images/default.png">
									<p class="msg">我的名字呀<br><span>ID：123456789</span></p>
									<p class="expenditure">88888.59万</p>
								</div>
								<div class="top3">
									<img src="@/assets/images/default.png">
									<p class="msg">我的名字呀<br><span>ID：123456789</span></p>
									<p class="expenditure">88888.59万</p>
								</div>
							</div>
							<div class="rank_bom" id="rankList">
								<div class="scroll">
									<div class="list clear">
										<span class="rank">198</span>
										<img src="@/assets/images/default.png" class="head_img">
										<div class="msg">我的名字叫阿萨尔利亚德国王<br><span>ID:123456789</span></div>
										<div class="expenditure">消费：<span>3456789.99万</span></div>
									</div>
								</div>
							</div>
						</div>
						<!-- 点赞 -->
						<div class="zanBox purpleBtn">
							<span class="iconfont icondianzan" @click="thumbsUpAnimate(111)"></span>
							<transition-group name="zanAnimate1">
								<img v-if="el==1" :src="levImg(el,4)" class="heart" :key="index" v-for="(el,index) in fabulousList">
							</transition-group>
							<transition-group name="zanAnimate2">
								<img v-if="el==2" :src="levImg(el,4)" class="heart" :key="index" v-for="(el,index) in fabulousList">
							</transition-group>
							<transition-group name="zanAnimate3">
								<img v-if="el==3" :src="levImg(el,4)" class="heart" :key="index" v-for="(el,index) in fabulousList">
							</transition-group>
							<transition-group name="zanAnimate4">
								<img v-if="el==4" :src="levImg(el,4)" class="heart" :key="index" v-for="(el,index) in fabulousList">
							</transition-group>
						</div>
						<!-- 礼物列表以及送礼 -->
						<div class="giftBox borderBox">
							<div class="giftContainer">
								<div id="giftBox" class="giftList borderBox" :class="moreGift?'allGift':''">
									<!-- 全部礼物 -->
									<div class="gift left" v-show="moreGift" :class="el.active?'active':''" v-for="(el,index) in giftList" @mouseover="getGiftDetail($event,el)" @mouseout="gift_detail_onoff(false)" @click="chooseGift(index)"><img :src="el.gift_image" ></div>
									<!-- 显示部分礼物 -->
									<div class="gift left" v-show="!moreGift" :class="el.active?'active':''" v-for="(el,index) in showGiftList" @mouseover="getGiftDetail($event,el)" @mouseout="gift_detail_onoff(false)" @click="chooseGift(index)"><img :src="el.gift_image" ></div>
								</div>
								<div class="giftDetail" v-show="giftDetailOpen" :style="'left:'+giftDetail.left+';top:'+giftDetail.top">
									<img :src="giftDetail.gift_image" class="giftImg">
									<p>{{giftDetail.gift_name}}&nbsp;&nbsp;{{giftDetail.gift_price}}U点<br>对方获得：{{giftDetail.gift_price*giftDetail.div}}积分</p>
								</div>
							</div>
							<div class="more" id="getMoreGift" @click="moreGift=!moreGift">{{moreGift?'∨':'∧'}}</div>
							<button class="purpleBtn sendBtn" @click="giftSend">赠送</button>
							<div class="account">
								账户余额：{{mcInfo_num.u}}U点
								<!-- <a v-if="Pid != 152" href="javascript:void(0);" class="purpleBtn" @click="addU">充值</a> -->
								<a href="javascript:void(0);" class="purpleBtn" @click="addU">充值</a>
								<div v-show="bShowChargeRemind" class="remind">								
								<div @click="addU"/>
								<div @click="closeRemind">
								</div>
							</div>
							</div>

							<div class="receiver">
								收礼人：<select class="sendToUser" v-model="giftId">
									<option :value="el.id" v-for="el in sendUserList">{{el.name|code}}</option>
									</select>
								数量： <select value="1" v-model="giftCount">
									<option v-for="(item,index) in giftNum" :key="index" v-bind:value="item" >{{item}}</option>
								</select>
							</div>
						</div>
						<!-- 刷礼跑道 -->
						<transition name="brushRoad">
							<div class="brush brush1" v-if="brush1">
								<div class="send">{{brush1.srcName}}</div>
								<div class="receive">
									送给 {{brush1.destName}}
								</div>
								<img :src="brush1.headPic" @error="defaultPic($event)" class="h_pic">
								<div class="giftMsg">
									<img :src="brush1.gift_img" class="giftPic">
									<img src="@/assets/images/numx.png" class="g_x">
									<div class="g_num">
										<img :src="levImg(el,6)" v-for="el in brush1.brushNum">
									</div>
								</div>
							</div>
						</transition>
						<transition name="brushRoad">
							<div class="brush brush2" v-if="brush2">
								<div class="send">{{brush2.srcName}}</div>
								<div class="receive">
									送给 {{brush2.destName}}
								</div>
								<img :src="brush2.headPic" @error="defaultPic($event)" class="h_pic">
								<div class="giftMsg">
									<img :src="brush2.gift_img" class="giftPic">
									<img src="@/assets/images/numx.png" class="g_x">
									<div class="g_num">
										<img :src="levImg(el,6)" v-for="el in brush2.brushNum">
									</div>
								</div>
							</div>
						</transition>
						<transition name="brushRoad">
							<div class="brush brush3" v-if="brush3">
								<div class="send">{{brush3.srcName}}</div>
								<div class="receive">
									送给 {{brush3.destName}}
								</div>
								<img :src="brush3.headPic" @error="defaultPic($event)" class="h_pic">
								<div class="giftMsg">
									<img :src="brush3.gift_img" class="giftPic">
									<img src="@/assets/images/numx.png" class="g_x">
									<div class="g_num">
										<img :src="levImg(el,6)" v-for="el in brush3.brushNum">
									</div>
								</div>
							</div>
						</transition>
						<!-- 中奖信息 -->
						<div class="zjBox">
							<div class="msg" v-if="prizeMsg">
								恭喜{{prizeMsg.nickname|code}}获得{{prizeMsg.times}}倍大奖
							</div>
						</div>
						<!-- 500倍以上大奖 -->
						<div class="bigPrizeBox" v-if="bigPrizeMsg">
							<img src="@/assets/images/prize/500.gif" class="bPic">
							<div class="name">{{bigPrizeMsg.nickname}}</div>
							<div class="times">
								<img :src="levImg(el,5)" v-for="el in bigPrizeMsg.times">
								<img src="@/assets/images/prize/num_x.png">
							</div>
						</div>
						<!-- <div class="leftCode" v-show="leftCode">
							<img src="@/assets/images/fb_mark.png">
							<div>扫码下载</div>
							<div class="close" @click="leftCode=false">Ⅹ</div>
						</div> -->
					</div>
				</div>
				<!-- 右边信息展示 -->
				<div class="rightBar borderBox">
					<!-- 个人名片 -->
					<div class="cardDetail" v-if="cardDetail" :style="'top:'+cardDetail.top+'px'">
						<div class="close" @click="closeCard">×</div>
						<img :src="cardDetail.photoPic" class="headPic" @error="defaultPic($event)">
						<div class="name">
							{{cardDetail.name|code}}
							<img v-if="cardDetail.sex==1" src="@/assets/images/sex/1.png">
							<img v-else src="@/assets/images/sex/0.png">
						</div>
						<div class="iconBox">
							<div class="levBox" :class="'lev'+cardDetail.pl1">
								<img :src="levImg(cardDetail.pl1,1)">
								{{cardDetail.pl2}}
							</div>
							<img v-show="cardDetail.sale" src="@/assets/images/icon1.png">
							<img v-show="cardDetail.fangguan" src="@/assets/images/icon2.png">
							<!-- <img src="@/assets/images/icon3.png"> -->
							<img v-if="cardDetail.guizuLev" :src="levImg(cardDetail.guizuLev,3)">
							<img v-if="cardDetail.lh" src="@/assets/images/levImg/lh.png">
						</div>
						<div class="id">ID:{{cardDetail.uid}}</div>
						<div class="btnBox" :class="cardDetail.uid==userInfo.user_id?'noclick':''">
							<span class="care borderBox" @click="careSomeone">{{cardDetail.care?'已关注':'关注'}}</span>
							<span @click="toGift">送礼</span>
						</div>
					</div>
					<!-- 观众列表以及家族列表 -->
					<div class="r_t">
						<div class="topTab">
							<div class="tabBar clear">
								<span :class="user_family==1?'active left':'left'" @click="changeList(1)">用户列表</span>  
								<div class="mid1">|</div>
								<div class="mid2">|</div>
								<span :class="user_family==2?'left active':'left'" @click="changeList(2)">家族列表</span>
								<span class="left" :class="user_family==3?'active':''" @click="changeList(3)">疯采榜</span>
							</div>
						</div>
						<div v-show="user_family==1" class="userList" id='userList' @scroll="userScroll($event)">
					       <div id="userScroll">
						       	<div class="list borderBox" v-for="el in newUserList" @click="getCardDetail(el,$event)">
							    	<img :src="el.photoPic" class="headpic" @error="defaultPic($event)">
							    	<img v-if="el.guizuLev" :src="levImg(el.guizuLev,3)">
							    	<img v-if="el.lh" src="@/assets/images/levImg/lh.png">
									{{el.name}}
									<!-- <button class="purpleBtn">关注</button> -->
							    </div>
					       </div>
						</div>
						<div id="familyList" v-show="user_family==2" class="userList familyList">
							 <div class="list borderBox" v-for="(el,index) in familyList" @click="mcTab(el.id,el.familyid)" :key='index' v-if="el.stype == 1"> <!--stype :1 视频 2 语音 3 星座 -->
						    	<img :src="'https://img.fengbolive.com/pic/avatar/'+el.id+'_'+el.phid+'_200*200.jpg'" @error="defaultPic($event)" class="headpic">
								{{el.name|code}}
						    </div>
						</div>
						<div class="fcrankBox" v-show="user_family==3">
							<div class="list" v-for="(el,index) in rankList">
								<img v-if="index==0" src="@/assets/images/rank1.png" class="top">
								<img v-if="index==1" src="@/assets/images/rank2.png" class="top">
								<img v-if="index==2" src="@/assets/images/rank3.png" class="top">
								<span class="index" v-if="index>2">{{index+1}}</span>
								<img :src="el.avatar" class="head" @error="defaultPic($event)">
								<div class="msgBox">
									{{el.nick_nm}}<br>
									<b>ID:{{el.user_id}}</b>
								</div>
								<div class="xf">
									消费：<span>{{el.ranking}}</span>
								</div>
							</div>
						</div>
					</div>
					<!-- 进场观众 -->
					<div class="r_m">
						<div id="inRoomBox" class="borderBox">
							<div class="scroll">
								<div class="list" :class="el.guizuLev?'guizu guizu'+el.guizuLev:''" v-for="el in inRoomList">
									<div class="levBox" :class="'lev'+el.pl1">
										<img :src="levImg(el.pl1,1)">
										<span class="right">{{el.pl2}}</span>
									</div>
									<img v-if="el.guizuLev" :src="levImg(el.guizuLev,3)">
									<img v-if="el.lh" src="@/assets/images/levImg/lh.png">
									<span>{{el.name|code}}</span>&nbsp;进入了房间
								</div>
							</div>
						</div>
					</div>
					<!-- 聊天窗口 -->
					<div class="m_b borderBox">
						<div id="chatBox">
							<div class="scroll">
								<div v-for="(el, index) in chatMsgList" :key="index">
									<div class="list" v-if="el.msgType == 1">
										<div :class="'levBox lev'+el.srcPl1">
											<img :src="levImg(el.srcPl1,1)">
											<span class="right">{{el.srcPl2}}</span>
										</div>
										<img v-if="el.guizu" :src="levImg(el.guizu,3)">
										<img v-if="el.lh" src="@/assets/images/levImg/lh.png">
										<span>{{el.srcName|code}}：</span>{{el.chatmsg}}
									</div>
									<div class="list" v-else-if="el.msgType == 2">
										<div :class="'levBox lev'+el.srcPl1">
											<img :src="levImg(el.srcPl1,1)">
											<span class="right">{{el.srcPl2}}</span>
										</div>
										<img v-if="el.guizu" :src="levImg(el.guizu,3)">
										<img v-if="el.lh" src="@/assets/images/levImg/lh.png">
										<span>{{el.nick_nm|code}}：</span>点亮了爱心
										<img src="@/assets/images/1.png" class="heartPic">
									</div>
									<div v-else-if="el.msgType == 3" class="xtMsg">{{el.content}}</div>
								</div>
							</div>
						</div>
						<div class="sendBox">
							<div class="danType borderBox" v-show="chatDan">
								<span :class="chatType==1?'active':''" class="borderBox" @click="danTab(1)">房间<br>2000U/条</span>
								<span :class="chatType==2?'active':''" class="borderBox" @click="danTab(2)">全站<br>5万U/条</span>
								<span :class="chatType==3?'active':''" class="borderBox" @click="danTab(3)">筋斗云<br>10万U/条</span>
							</div>
							<div class="danBox" :class="chatDan?'active':''" @click="openChatDan">
								<span :class="chatDan?'right':'left'">弹</span>
							</div>
							<input type="text" placeholder="说点什么吧" @keyup.enter="chatMsgsend" v-model="chatMsg" maxlength="140">
							<button class="purpleBtn" @click="chatMsgsend">发送</button>
							<div class="loginTips" v-show="!userInfo.photo_num"><span @click="showLogin">登录</span>后才能聊天哦</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 猜你喜欢 -->
			<h2 class="like">
				<img src="@/assets/images/listIcon.png">
				猜你喜欢
			</h2>
			<ul class="likeList clear">
				<!-- <div class="list borderBox left" v-for="el in hotList" @click="toLive(el.id)">
					<div class="maskBox">
						<div class="playIcon">
							<span class="iconfont iconbofang"></span>
						</div>
					</div>
					<img :src="el.img" class="coverImg" @error="defaultPic($event)">
					<p><img :src="el.img" @error="defaultPic($event)">{{el.name|code}}</p>
				</div> -->
				<mcItem v-for="(item,index) in hotList" :itemData="item" :key="index" @onClickHotListAnchor="toLive"></mcItem>
			</ul>
			<footerBox></footerBox>
		</div>
	</div>
</template>
<script>
import footerBox from "@/components/footer";
import livePlayBox from "@/components/livePlayBox";
import windowBox from "@/components/window";
import logincard from "@/components/loginUserCard";
import mcItem from "@/components/anchorCard/anchorListItem";
import '@/js/my_scrollbar.js';
import jsonpAdapter from 'axios-jsonp';
import crypt from '@/js/utils/crypt.js';
var socket=null;
var timer=null;
var offline=false;
var websocketTimer=null;
var loginRemindTimer=null;
export default {
	name: "live",
	data(){
		return{
			leftCode:true,
			previewAnchorId:Number(this.$route.params.id),
			//礼物数量
			giftNum:[1,11,66,188,520,1314,9999],
			//观众列表的滚动条
			userListBar:null,
			//家族列表的滚动条
			familyListBar:null,
			//进入房间滚动条
			inRoomBar:null,
			//聊天信息滚动条
			chatBar:null,
			//礼物浮窗
			giftDetail:{left:'20px',bottom:'80px'},
			//礼物列表
			giftList:[],
			showGiftList:[],
			//更多礼物
			moreGift:false,
			//礼物详情开关
			giftDetailOpen:false,
			//家族列表
			familyList:[],
			//用户列表和家族列表切换
			user_family:1,
			//用户列表
			userList:[],
			newUserList:[],
			userListPage:0,
			userScrollLock:false,
			sendUserList:[],
			rankList:[],
			zanList:[],
			//协议初始化数据
			initParam:null,
			//进入房间列表
			inRoomList:[],
			//聊天信息列表
			chatMsgList:[],
			chatMsg:'',
			chatType:1,
			chatDan:false,
			//等级信息
			levMsg:{consumebase:1,consumelevle:1,incomebase:1,incomelevle:1},
			//关注以及粉丝信息
			mcInfo_num:{follow_num:0,fans_num:0,isFollow:false,u:0},
			//登录包信息
			loginData:{pl1: 1, pl2: 0, name: '游客89757'},
			//观看人数
			watchNum:0,
			fengcai:0,
			fabulousList:[],
			close:false,
			//弹幕列表
			dan1List:[],
			dan2List:[],
			dan3List:[],
			dan4List:[],
			dan5List:[],
			//中奖信息
			prizeList:[],
			prizeMsg:null,
			prizeBool:true,
			bigPrizeList:[],
			bigPrizeMsg:null,
			bigPrizeBool:true,
			hotList:[],
			//是否正常退出协议
			quite:false,
			giftId:null,
			giftCount:1,
			brush1:null,
			brush2:null,
			brush3:null,
			brushList:[],
			cardDetail:null,
			bShowChargeRemind:true,
			// 连麦相关数据
			linkData:{
				status:false,
				linkPic:false,
				active:1,
				destId:0,
			},
			// pk相关数据
			pkData:{
				status:false,
				pkPic:false,
				blueScore:0,
				blueAdd:[],
				redScore:0,
				redAdd:[],
				bluePercent:50,
				redPercent:50,
				result:0,
				luckyTime:false,
				pkTime:300,
			},
		}
	},
	components: {footerBox,livePlayBox,windowBox ,logincard,mcItem},
	filters:{
		toFengcai(val){
			return (Math.floor(val / 1000) / 10).toFixed(1) + '万'
		},
		code(val){
			return decodeURIComponent(val);
		},
		getCurrentTime(time){
		    var year = time.getFullYear();
		    var month = time.getMonth()+1;
		    var date = time.getDate();
		    if(month<10){
		        month = "0"+month;
		    }
		    if(date < 10){
		        date = "0"+date;
		    }
		    return year + '-' + month + '-' + date;
		},
		pktime(num){
			var num=parseInt(num);
			var minute=parseInt(num/60);
			var second=num%60;
			second = second<10?'0'+second:second;
			return '0'+minute+':'+second;
		}
	},
	beforeCreate(){
		if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
		  location.replace('https://wt.sinashow.com/flive.html?aid='+this.$route.params.id);
		}
	},
	mounted:function(){
		var that=this;
		var videoWidth=parseInt(getComputedStyle(document.getElementById('videoBox')).width);
		document.getElementById('videoBox').setAttribute('style','height:'+(videoWidth*0.56)+'px');
		            // 注：window.onresize只能在项目内触发1次
		window.onresize = function () {
			// 通过捕获系统的onresize事件触发我们需要执行的事件
			var videoWidth=parseInt(getComputedStyle(document.getElementById('videoBox')).width);
			document.getElementById('videoBox').setAttribute('style','height:'+(videoWidth*0.56)+'px');
			that.giftSize();
		}
		document.getElementById('livePage').onclick=function(event){
			event.stopPropagation();
			var event = event || window.event;
	        var targetId = event.target ? event.target.id : event.srcElement.id;
	        if( targetId != 'getMoreGift'&&targetId != 'giftBox'){
	            if(that.moreGift){
	            	that.moreGift=false;
	            }
	        }
		}
		this.inRoomBar=new MyScrollBar({
		    selId:'inRoomBox',
		})
		this.chatBar=new MyScrollBar({
		    selId:'chatBox',
		})
		//礼物列表
		this.axios({
			method:'GET',
			url:location.protocol+'//live.fengbolive.com/list/props/red_gift.json',
		}).then(res=>{
			res=res.data[0].gift_item;
			var i = 0;
			var listArray=[];
            for(var k=0;k<res.length;k++){
                if(res[k].gift_id == '60001' || res[k].identity == 1 || res[k].gift_id == '1000010'){
                    continue;
                }
                res[k].gift_image=res[k].gift_image.replace('http','https')+res[k].gift_id+'_a_t.png';
                listArray[i] = res[k];
                i++;
            }
            this.giftList=listArray;
            setTimeout(this.giftSize,50)
		})

		if (loginRemindTimer != null) {
			clearTimeout(loginRemindTimer);
			loginRemindTimer = null;
		}
		if (!this.userInfo.photo_num) {
			this.$store.dispatch('upDataWindowBoxShowBool',{msg:'您当前为游客登陆，还可以试看1分钟，注册登录后看直播不受限制呦'});
			loginRemindTimer = setTimeout(function () {
				if(!that.userInfo.photo_num && !that.$store.state.loginUserInfo.info.photo_num){
					that.$router.push({path:'/index'});
					that.$store.commit('LOGINREGBOX_SHOW_HIDE_CLOSE',false);
					that.$store.dispatch('upDataLoginRegShowBool',1);
				}
				clearTimeout(loginRemindTimer);
				loginRemindTimer = null;
			}, 1000 * 20 * 1);
		}
	},
	methods:{
		giftSize(){
			var giftWidth=parseInt(getComputedStyle(document.getElementById('videoBox')).width)-180;
			var size =Math.floor(giftWidth/67);
			var active=false;
			var newArr=[];
			for(var i=0;i<this.giftList.length;i++){
				if(this.giftList[i].active){
					active=i;
					break
				}
			}
			if(active){
				var start=Math.floor(active/size)*size;
			}else{
				var start=0;
			}
			var length=start+size>this.giftList.length?this.giftList.length:start+size
			for(var j=start;j<length;j++){
				newArr.push(this.giftList[j]);
			}
			this.showGiftList=newArr;
		},
		mcCallBack(){
			if(!this.mcInfo){
				this.$router.push({path:'/index'});
				this.$store.dispatch('upDataWindowBoxShowBool',{msg:'未找到相关主播信息~'});
				return
			}
			this.getHotList(1);
			this.sendUserList.push({name:this.mcInfo.name,id:this.mcInfo.id});
			this.giftId=this.mcInfo.id;
			//是否是游客
			if(this.userInfo.photo_num){
				this.getMcInfo_num();
			}
			//主播等级信息
			this.axios({
				method:'post',
				url:location.protocol + '//api.fengbolive.com/userinfo/getuserinfo/getlevle.html',
				data:this.$common.changeobj({user_id:this.userInfo.user_id,uid:this.mcInfo.id,reg_mac:localStorage.getItem('mac'),token:this.$store.state.loginUserInfo.token})
			}).then(res=>{
				if(res.data.code==1){
					this.levMsg=res.data.data;
				}
			})
			var time=parseInt(new Date().getTime()/1000);
			var sign=this.$md5(this.userInfo.user_id+localStorage.getItem('FamilyId')+'501get_family_anchor'+this.$store.state.loginUserInfo.token+time+'jsonCallBack');
			var data={
	            uid:this.userInfo.user_id,
	            familyId: localStorage.getItem('FamilyId'),
	            limit:50,
	            page:1,
	            token:this.$store.state.loginUserInfo.token,
	            timeStamp:time,
	            sign:sign
	        }
	        if(data.familyId!=0){
				//家族列表
				this.axios.jsonp('https://external.fengbolive.com/cgi-bin/get_family_anchor_h5.fcgi?'+this.$common.changeobj(data)).then(res=>{
					this.familyList=res.info;
				})
	        }else{
	        	this.familyList.push(this.mcInfo);
	        }
			if(window.location.protocol == 'http:'){
	            var urlType = 'http';
			}else if(window.location.protocol == 'https:'){
	            var urlType = 'https';
			}
			this.axios({
				url:window.location.protocol+'//app.fengbolive.com/frontend/web/index.php?r=rankinglist/ajaxcontribution',
				method:'post',
				data:this.$common.changeobj({
					page:1,
	                uid:this.userInfo.user_id,
	                user_id:this.mcInfo.id,
	                token:this.$store.state.loginUserInfo.token,
	                urlType:urlType
				})
			}).then(res=>{
				res=res.data;
				if(res.code==1&&res.top.length>0){
					this.rankList=res.top.concat(res.info);
				}
			})
			//return
			this.openSocket();
		},
		openSocket(){
			//websocket 相关
			if(window.WebSocket){
				var that=this;
				this.initData();
				offline=false;
				socket=new WebSocket(this.initParam.pip);
				socket.onopen=function(){
					console.log('开始时间：' + new Date().toLocaleString());

					websocketTimer=setTimeout(function () {
	                    if (socket.readyState != 1) {
							// that.$router.push({path:'/index'});
	                        that.$store.dispatch('upDataWindowBoxShowBool',{msg:'小主，网络走丢了~'});
	                    	offline=false;
	                    }else{
	                    	offline=true;
	                    }
	                }, 3000)
	                //console.log(new Date().getTime(),JSON.stringify(that.initParam));
	                socket.send(that.initMsg());
	                timer=setInterval(that.heartMsg,20000);
					that.quite=false;
					that.close=false;
				}
				socket.onmessage=function(msg){
					try {
						var backData = JSON.parse(crypt.decrypt(msg.data));
					} catch (e) {
						console.log('错误消息', msg, crypt.decrypt(msg.data));
					}
					if (!backData) {
						return;
					}
					if (backData.htype == 6302) {
	                    if (backData.ret != 0) {
	                        if (backData.reason) {
	                            setTimeout(function () {
	                            	that.$router.push({path:'/index'});
	                                that.$store.dispatch('upDataWindowBoxShowBool',{msg:backData.reason,type:3});
	                            }, 500)
	                            return
	                        }
	                    }
	                    //返回的用户登陆包信息
	                    if (that.userInfo.photo_num) {
	                    	if(backData.lnobility && backData.lnobility!=0){
		                		backData.guizu=backData.lnobility/10;
		                	}
		                	if(backData.identity){
		                		for(var i=0;i<backData.identity.length;i++){
		                			if(backData.identity[i].miType==61){
		                				backData.lh=true;
		                			}
		                		}
				            }
				            if(!backData.lh){
				            	backData.lh=false;
							}
	                    	that.loginData=backData;
	                    }else{
	                    	that.loginData={pl1: 1, pl2: 0, name: that.userInfo.nick_nm}
	                    }
	                }
	                //用户列表
	                if(backData.htype==6356){
	                	that.userListBloodshed(backData);
	                }
	                //用户进房
	                if(backData.htype==6314){
	                	if(backData.identity){
		                	for(var i=0;i<backData.identity.length;i++){
				                if(backData.identity[i].mitype==9||backData.identity[i].miType==9){
				                	backData.guizuLev=parseInt(backData.identity[i].milev)/10;
				                }
				                if(backData.identity[i].mitype==61||backData.identity[i].mitype==63){
				                    backData.lh=true;
				                }

				            }
	                    }
	                	that.inRoomList.push(backData);
	                    setTimeout(function(){
	                    	that.inRoomBar.jump({pos:'bottom',time:300});
	                    },300)
	                    that.watchNum=backData.usrCount;
	                    that.userList.push(backData);
	                    that.inRoomBar.setSize();
	                    that.showUserList();
	                }
	                //离开房间
	                if(backData.htype==6358){
	                	that.watchNum=backData.usrCount;
	                	that.showUserList(backData.srcUid);
	                	if(backData.srcUid==that.userInfo.user_id){
	                		socket.quite();
	                		that.$router.go(-1);
	                	}
	                }
	                //系统消息
	                if(backData.htype==6357){
						that.fengcai=backData.atotal;
						let obj = {
							msgType:3,
							content:backData.msg[0].content
						}
	                	//that.chatMsgList.push(backData.msg[0].content);
	                	that.chatMsgList.push(obj);
			            that.chatBar.setSize();
		            	setTimeout(function(){
		            		that.chatBar.jump({pos:'bottom',time:300});
		            	},300)
	                }
	                //主播疯采值变化
	                if(backData.htype==6309){
						that.fengcai=backData.atotal;
						if(that.pkData.status){
							if(that.linkData.active==1){
								var exp=that.pkData.blueScore;
								that.pkData.blueAdd.push(backData.exp-exp);
								that.pkData.blueScore=backData.exp;
							}else{
								var exp=that.pkData.redScore;
								that.pkData.redAdd.push(backData.exp-exp);
								that.pkData.redScore=backData.exp;
							}
							that.scoreComputed();
						}
	                }
					if(backData.htype==6360){//用户U点更新
	                	that.mcInfo_num.u=backData.arvalue;
	                }
	                if(backData.htype==5645){
	                	that.thumbsUpAnimate();
	                	if(that.zanList.indexOf(backData.uid)!=-1){
	                		return
	                	}
	                	that.zanList.push(backData.uid);
	                	if(backData.uid>910000000&&backData.uid<919999999){
	                		var user={
	                			nick_nm:'游客'+backData.uid,
	                			srcPl1:1,
								srcPl2:0,
								msgType:2
	                		}
	                		that.chatMsgList.push(user);
	                		that.chatBar.setSize();
			            	setTimeout(function(){
			            		that.chatBar.jump({pos:'bottom',time:300});
			            	},300)
			            	return
	                	}
	                	that.axios({
							url:location.protocol + "//api.fengbolive.com/userinfo/getinfo.html?"+that.$common.changeobj({
								uid: backData.uid,
								user_id: that.userInfo.user_id,
								reg_mac: localStorage.getItem('mac'),
								token: that.$store.state.loginUserInfo.token,
								ver: that.$store.state.loginUserInfo.version,
								pid: that.$store.state.loginUserInfo.pid
							}),
							adapter: jsonpAdapter
						}).then(res=>{
							res=res.data;
							if(res.code==1){
								var data=res.data;
								var user={};
								user.nick_nm=data.nick_nm;
								if(data.identity){
									for(var i=0;i<data.identity.length;i++){
										if(data.identity[i].miType==9){
					                    	user.guizu=parseInt(data.identity[i].miLevel)/10;
					                    }else if(data.identity[i].mitype==9){
					                        user.guizu=parseInt(data.identity[i].milevel)/10;
					                    }
					                    if(data.identity[i].mitype==61||data.identity[i].mitype==63||data.identity[i].miType==61||data.identity[i].miType==63){
							                user.lh=true;
							            }
									}
								}

							}
							var parData = {
								user_id:that.userInfo.user_id,
								token: that.$store.state.loginUserInfo.token,
								reg_mac: localStorage.getItem('mac'),
								uid:backData.uid,
							};
							that.axios({
								url:"https://api.fengbolive.com/userinfo/getuserinfo/getlevle.html?" + that.$common.changeobj(parData),
								method:'post'
							}).then(res=>{
								data=res.data;
								if(data.code==1){
									user.srcPl1=data.data.consumebase;
									user.srcPl2=data.data.consumelevle;
									user.msgType = 2;
									that.chatMsgList.push(user);
						            that.chatBar.setSize();
					            	setTimeout(function(){
					            		that.chatBar.jump({pos:'bottom',time:300});
					            	},300)
								}
							});
						})
	                }
	                if(backData.htype==6327){//用户处理
	                	if(backData.mType==14||backData.mType==15||backData.mType==16){
	                		if(backData.uid==that.userInfo.user_id){
	                			socket.quite();
	                			offline=false;
								that.$router.push({path:'/index'});
								if (backData.describe && backData.describe != '') {
									that.$store.dispatch('upDataWindowBoxShowBool',{msg:backData.describe});
								}
							}
							let obj = {
								msgType:3,
								content:'系统消息：[ '+backData.name+' ]被无情的请出了直播间'
							}
		                	//that.chatMsgList.push('系统消息：[ '+backData.name+' ]被无情的请出了直播间');
		                	that.chatMsgList.push(obj);
				            that.chatBar.setSize();
			            	setTimeout(function(){
			            		that.chatBar.jump({pos:'bottom',time:300});
			            	},300)
	                	}
	                }
	                if(backData.htype==6361){//错误提示
	                	if(backData.type==1){
	                		// this.$router.push({path:'/index'});
							this.$store.dispatch('upDataWindowBoxShowBool',{msg:'小主，网络走丢了~'});
	                	}
	                }
	                if (backData.htype == 6326) {//主播下播
	                    that.close = true;
	                    that.quite = true;
	                    offline=false;
	                    socket.quite();
	                }
					if(backData.htype == 6323){//聊天信息
	                	if(!backData.srcPl1){
	                		backData.srcPl1=1;
	                	}
	                	if(!backData.srcPl2){
	                		backData.srcPl2=0;
	                	}
	                	if(backData.lnobility && backData.lnobility!=0){
	                		backData.guizu=backData.lnobility/10;
	                	}
	                	if(backData.identity){
			                var liang=backData.identity.toString(2).substr(2,1);
			                //var fangguan=backData.identity.toString(2).substr(2,1);
			                if(liang==1){
			                    backData.lh=true;
			                }else{
			                	backData.lh=false;
			                }
						}
						backData.msgType = 1;
	                	that.chatMsgList.push(backData);
	                	that.chatBar.setSize();
	                	setTimeout(function(){
	                		that.chatBar.jump({pos:'bottom',time:300});
	                	},300)
	                }
					if(backData.htype==6366){//请求连麦
						that.linkData.status=true;
						that.linkData.linkPic=true;
						that.linkData.destId=backData.destAnchor;
						setTimeout(function(){that.linkData.linkPic=false},2000);
						that.linkData.active=backData.isActive;//1为左边视频
	                	setTimeout(function(){
	                		that.$refs.video.switchUrl(3,backData.url);
	                	},5000)
					}
					if(backData.htype==6371){//进入连麦直播间
						that.linkData.status=true;
						that.linkData.active=backData.isActive;//1为左边视频
						that.linkData.destId=backData.destAnchor;
						if(backData.pkMicState){
							that.pkData.status=true;
							that.pkData.pkTime=backData.pkTime;
							that.pkData.pkPic=true;
							setTimeout(function(){that.pkData.pkPic=false},2000);
							var pkTimer=setInterval(function(){
								that.pkData.pkTime--;
								if(that.pkData.pkTime<=0){
									clearInterval(pkTimer);
								}
							},1000)
							if(backData.isActive==1){
								that.pkData.blueScore=backData.score;
								that.pkData.redScore=backData.destScore;
							}else{
								that.pkData.redScore=backData.score;
								that.pkData.blueScore=backData.destScore;
							}
							that.scoreComputed();
						}else{
							that.linkData.linkPic=true;
							setTimeout(function(){that.linkData.linkPic=false},2000);
						}
					}
					if(backData.htype==6365){//请求pk 返回
						console.log('请求pk',backData);
						if(backData.res==1){
							that.linkData.linkPic=false;
							that.pkData.status=true;
							that.pkData.pkPic=true;
							that.pkData.bluePercent=50;
							that.pkData.redPercent=50;
							setTimeout(function(){that.pkData.pkPic=false},2000);
							that.pkData.blueScore=0;
							that.pkData.redScore=0;
							that.pkData.pkTime=backData.pkTime;
							var pkTimer=setInterval(function(){
								that.pkData.pkTime--;
								if(that.pkData.pkTime<=0){
									clearInterval(pkTimer);
								}
							},1000)
						}
					}
					if(backData.htype==6367){//对端主播经验
						if(that.linkData.active==1){
							var exp=that.pkData.redScore;
							that.pkData.redAdd.push(backData.exp-exp);
							that.pkData.redScore=backData.exp;
						}else{
							var exp=that.pkData.blueScore;
							that.pkData.blueAdd.push(backData.exp-exp);
							that.pkData.blueScore=backData.exp;
						}
						that.scoreComputed();
					}
					if(backData.htype==6368){//pk结束
						that.pkData.status=false;
						if(backData.result==1){
							if(that.linkData.active==1){
								that.pkData.result=1;
							}else{
								that.pkData.result=2;
							}
						}else{
							if(that.linkData.active!=1){
								that.pkData.result=1;
							}else{
								that.pkData.result=2;
							}
						}
						setTimeout(function(){
							that.pkData.result=0;
						},60000)
					}
					if(backData.htype==6364){//连麦结束
						that.linkData.status=false;
	                	setTimeout(function(){
	                		that.$refs.video.switchUrl(1);
	                	},3000)
					}
					if (backData.htype == 6330) {//弹幕
	                	var random=Math.floor((Math.random(0,1)*25+7));
						backData.top=random+'%';
						backData.img=that.$common.getPhotoUrl(backData.fid,backData.fpnum,2);
	                    if (backData.distype == 1) {             //全站
	                        that.dan2List.push(backData);
	                    } else if (backData.distype == 2) {      //筋斗云
	                        that.dan3List.push(backData);
	                    } else if (backData.distype == 3) {       //房间内
	                    	that.dan1List.push(backData);
						}else if(backData.distype == 4){//礼物中奖全站飘条
							var giftList=that.giftList;
							for(var i=0;i<giftList.length;i++){
								if(giftList[i].gift_id==backData.gid){
									backData.gift_image=giftList[i].gift_image;
									break
								}
							}
							backData.str=decodeURIComponent(backData.gctent);
							backData.str=backData.str.replace(/\+/g,'').replace('$2','<span style="color:#F1FA81">'+decodeURIComponent(backData.fname+'</span>')).replace('$7','<span style="color:#F1FA81">'+backData.gname+'</span>').replace('$b','<span style="color:#F1FA81">'+backData.pcount+'</span>').replace('$c','<span style="color:#F1FA81">'+parseInt(backData.ppoint/10000)+'万</span>');
							if(backData.barrage_type==0){
								that.dan4List.push(backData);
							}else{
								that.dan5List.push(backData);
							}
	                    }else{
	                    	console.log('其他飘条',backData);
	                    }
	                }
	                //普通升级
	                if(backData.htype==6324){
	                	if(backData.effect==1){
	                		//console.log('升级',backData);
	                		//用户等级
	                		if(backData.type==1){
	                			if(backData.uid==that.mcInfo.id){
	                				that.levMsg.consumebase=backData.base;
	                				that.consumelevle=backData.level;
	                			}else{

	                			}
	                		}
	                		//主播等级
	                		if(backData.type==2){
	                			if(backData.uid==that.mcInfo.id){
	                				that.levMsg.incomebase=backData.base;
	                				that.incomelevle=backData.level;
	                			}else{

	                			}
	                		}
	                	}
	                }
	                if(backData.htype==6332){//中奖信息
	                	if(backData.srcuid==that.userInfo.user_id){
	                		that.mcInfo_num.u=backData.totalBalance;
	                	}
	                	if(backData.times<500){
	                		that.prizeList.push(backData);
	                		if(that.prizeBool){
	                			that.getPrizeMsg();
	                		}
	                	}else{
	                		backData.times=String(backData.times).split('');
	                		that.bigPrizeList.push(backData);
	                		if(that.bigPrizeBool){
	                			that.getBigPrizeMsg();
	                		}
	                	}
	                }
	                //刷礼
	                if(backData.htype==6359){
	                	if(backData.beginNum==1){
	                		//console.log(backData);
	                		that.getGiftList(backData);
	                	}
	                }
	                //全站礼物
	                if(backData.htype==6329){
	                	var random=Math.floor((Math.random(0,1)*25+7));
	                	backData.top=random+'%';
	                	backData.img=that.$common.getPhotoUrl(backData.fid,backData.fpnum,2);
	                	backData.gctent=backData.fname+'挥一挥手送给了'+backData.tname+'一个'+backData.gname;
	                	that.dan2List.push(backData);
					}
					//luckyTime开启
					if(backData.htype==6369){
						that.pkData.luckyTime=true;
					}
					//luckyTime关闭
					if(backData.htype==6370){
						that.pkData.luckyTime=false;
					}

				}
				socket.onclose=function(e){
					console.log('结束时间：' + new Date().toLocaleString());
					if(offline){
						that.openSocket();
						return
					}
					if(!that.quite){
						// that.$router.push({path:'/index'});
	                    that.$store.dispatch('upDataWindowBoxShowBool',{msg:'小主，网络走丢了~'});
					}
				}
				socket.quite=function(){
					console.log('退出协议');
					/*var quiteData = {};
			        quiteData.srcUid = that.initParam.uid;
			        quiteData.roomid = that.initParam.rid;
			        quiteData.htype = 6351;
			        var quiteDataString = JSON.stringify(quiteData);
			        var len = quiteDataString.length;
			        var encryptData = encodeURIComponent(crypt.encrypt(quiteDataString));
			        var sendQuite = {};
			        sendQuite.vcnt = encryptData;
			        sendQuite.clen = len;
			        var sendQuite = JSON.stringify(sendQuite);
			        socket.send(sendQuite);*/
					that.quite=true;
					offline = false;
			        socket.close();
				}
			}else{
				this.$store.dispatch('upDataWindowBoxShowBool',{msg:'版本过低，请使用最新版本'});
			}
			window.onbeforeunload = function(event) {
				clearInterval(timer);
			    offline=false;
			    window.onresize=null;
			    document.getElementById('livePage').onclick=null;
			    if(socket){
					socket.quite();
			    }
			};
		},
		//中奖信息
		getPrizeMsg(){
			var that=this;
			that.prizeBool=false;
			if(this.prizeList[0]){
				this.prizeMsg=this.prizeList[0];
				this.prizeList.shift();
				setTimeout(function(){
					that.prizeMsg=null;
					setTimeout(that.getPrizeMsg,10);
				},2000)
			}else{
				that.prizeBool=true;
			}
		},
		getBigPrizeMsg(){
			var that=this;
			that.bigPrizeBool=false;
			if(this.bigPrizeList[0]){
				this.bigPrizeMsg=this.bigPrizeList[0];
				this.bigPrizeList.shift();
				setTimeout(function(){
					that.bigPrizeMsg=null;
					setTimeout(that.getBigPrizeMsg,10);
				},3000)
			}else{
				that.bigPrizeBool=true;
			}
		},
		//登录弹窗
		showLogin(){
			this.$store.dispatch('upDataLoginRegCloseBtnShowBool',true);
			this.$store.dispatch('upDataLoginRegShowBool',1);
		},
		onClickFollow(){
			if(!this.userInfo.photo_num){
				this.$store.dispatch('upDataWindowBoxShowBool',{msg:'登录后才可以关注主播哦~',type:4});
			}else if(this.mcInfo_num.isFollow){
				var time = parseInt(new Date().getTime()/1000);
				var sign = this.$md5(this.userInfo.user_id+'add_follow'+this.mcInfo.id+this.$store.state.loginUserInfo.version+this.$store.state.loginUserInfo.token+localStorage.getItem('mac')+time);
				//取消关注
				var data={
			        'isJump':1,
			        'type':'c',
			        'user_id':this.userInfo.user_id,
			        'uid':this.mcInfo.id,
			        'token':this.$store.state.loginUserInfo.token,
			        'version':this.$store.state.loginUserInfo.version,
			        'reg_mac':localStorage.getItem('mac'),
			        'pid':this.$store.state.loginUserInfo.pid,
			        'timestamp':time,
			        'sign':sign
				}
				this.axios({
					url:'https://external.fengbolive.com/cgi-bin/add_follow.fcgi?'+this.$common.changeobj(data),
					adapter: jsonpAdapter
				}).then(res=>{
					if(res.data.ret==0){
						this.mcInfo_num.isFollow=false;
					}
				})
			}else{
				var time = parseInt(new Date().getTime()/1000);
				var sign = this.$md5(this.userInfo.user_id+'add_follow'+this.mcInfo.id+this.$store.state.loginUserInfo.version+this.$store.state.loginUserInfo.token+localStorage.getItem('mac')+time);
				//关注
				var data={
			        'isJump':1,
			        'type':'f',
			        'user_id':this.userInfo.user_id,
			        'uid':this.mcInfo.id,
			        'token':this.$store.state.loginUserInfo.token,
			        'version':this.$store.state.loginUserInfo.version,
			        'reg_mac':localStorage.getItem('mac'),
			        'pid':this.$store.state.loginUserInfo.pid,
			        'timestamp':time,
			        'sign':sign
				}
				this.axios({
					url:'https://external.fengbolive.com/cgi-bin/add_follow.fcgi?'+this.$common.changeobj(data),
					adapter: jsonpAdapter
				}).then(res=>{
					if(res.data.ret==0){
						this.mcInfo_num.isFollow=true;
					}
				})
			}
		},
		getGiftList(data){
			var that=this;
			for(var i=0;i<that.giftList.length;i++){
				if(that.giftList[i].gift_id==data.propID){
					data.gift_img=that.giftList[i].gift_image;
				}
			}
			data.headPic=this.$common.getPhotoUrl(data.srcUid,data.srcPhoto,2);
			data.brushNum=String(data.useCount).split('');
			data.time=new Date().getTime();
			if(this.brush1&&data.destUid==this.brush1.destUid && data.propID==this.brush1.propID && data.srcUid==this.brush1.srcUid){
				this.brush1.useCount+=data.useCount;
				this.brush1.time=new Date().getTime();
				this.brush1.brushNum=String(this.brush1.useCount).split('');
			}else if(this.brush2&&data.destUid==this.brush2.destUid && data.propID==this.brush2.propID && data.srcUid==this.brush2.srcUid){
				this.brush2.useCount+=data.useCount;
				this.brush2.brushNum=String(this.brush2.useCount).split('');
				this.brush2.time=new Date().getTime();
			}else if(this.brush3&&data.destUid==this.brush3.destUid && data.propID==this.brush3.propID && data.srcUid==this.brush3.srcUid){
				this.brush3.useCount+=data.useCount;
				this.brush3.time=new Date().getTime();
				this.brush3.brushNum=String(this.brush3.useCount).split('');
			}else if(!this.brush1){
				this.brush1=data;
				data.timer=setInterval(function(){
					var now=new Date().getTime();
					if(now-that.brush1.time>3000){
						clearInterval(data.timer);
						that.brush1=null;
					}
				},1000)
			}else  if(!this.brush2){
				this.brush2=data;
				data.timer=setInterval(function(){
					var now=new Date().getTime();
					if(now-that.brush2.time>3000){
						clearInterval(data.timer);
						that.brush2=null;
					}
				},1000)
			}else  if(!this.brush3){
				this.brush3=data;
				data.timer=setInterval(function(){
					var now=new Date().getTime();
					if(now-that.brush3.time>3000){
						clearInterval(data.timer);
						that.brush3=null;
					}
				},1000)
			}else{
				setTimeout(function(){
					that.getGiftList(data);
				},1000)
			}
		},
		//开关全部礼物界面
		moreGiftBstop(){
			if(this.moreGift){
				this.moreGift=false;
			}else{
				this.moreGift=true;
			}
		},
		//开关礼物详情
		gift_detail_onoff(bool){
			this.giftDetailOpen=bool;
		},
		//礼物详情赋值
		getGiftDetail(event,el){
			this.gift_detail_onoff(true);
			el.top=event.target.offsetTop-105+'px';
			var left=event.target.offsetLeft-120>20?event.target.offsetLeft-120:20;
			el.left=left+'px';
			this.giftDetail=el;
		},
		//选中礼物
		chooseGift(index){
			if(this.moreGift){
				for(var i=0;i<this.giftList.length;i++){
					this.giftList[i].active=false;
				}
				this.giftList[index].active=true;
				if(this.giftList[index].gift_property==1||this.giftList[index].gift_property==4||this.giftList[index].gift_property==3){
					this.giftNum=[1,11,66,188,520,1314,9999];
				}else{
					this.giftNum=[1];
					this.giftCount=1;
				}
			}else{
				for(var i=0;i<this.showGiftList.length;i++){
					this.showGiftList[i].active=false;
				}
				this.showGiftList[index].active=true;
				if(this.showGiftList[index].gift_property==1||this.showGiftList[index].gift_property==4||this.showGiftList[index].gift_property==3){
					this.giftNum=[1,11,66,188,520,1314,9999];
				}else{
					this.giftNum=[1];
					this.giftCount=1;
				}
			}
		},
		//用户列表-家族列表切换
		changeList(index){
			this.user_family=index;
		},
		//主播切换
		mcTab(id,familyId){
			localStorage.setItem('AnchorId',id);
			localStorage.setItem('FamilyId',familyId);
			if(id!=this.mcInfo.id){
				//跳转至本页
				this.$router.push({
		          path: '/live/'+id,
		        })
		        //this.$router.go(0);
			}
		},
		//websocket信息初始化
		initData: function () {
			var data = {};
			for(var i=0;i<this.mcInfo.ip.length;i++){
				if(this.mcInfo.ip[i].isp==3){
					data.aport = Number(this.mcInfo.ip[i].port);
					data.aip = this.mcInfo.ip[i].ip;
				}
			}
			data.aid = String(this.mcInfo.id);
			data.uid = String(this.userInfo.user_id);
			data.rid = this.mcInfo.roomid;
			data.nick = this.userInfo.nick_nm;
			data.upwd = "111111"; //用户密码
			data.pnum = Number(this.userInfo.photo_num)||0;
			data.ver = this.mcInfo.anchorstate & 0x0100 > 0 ? '2.5.000' : '2.45.390';;
			data.cver = this.$store.state.loginUserInfo.version;
			data.state = Number(this.mcInfo.anchorstate & 0x0100);
			data.pid = Number(this.$store.state.loginUserInfo.pid);
			data.mac = localStorage.getItem('mac');
			data.token = this.$store.state.loginUserInfo.token;
			data.htype = 6301;
			data.pip = 'wss://wxsp.fengbolive.com';
			data.support_func=3;
			this.initParam=data;
		},
	    //初次信息
	    initMsg(){
	    	//console.log(JSON.stringify(this.initParam),new Date().getTime())
			var sendData = { 
			  ktype: 2,
			  vcnt: encodeURIComponent(crypt.encrypt(JSON.stringify(this.initParam))),
			  clen: JSON.stringify(this.initParam).length
			};
			var initData = JSON.stringify(sendData);
			return initData;
	    },
	    //心跳包
	    heartMsg(){
	      if(socket.readyState!=1){
	      	return
	      };
	      var data = {};
	      var len;
	      var sendData = {
	          ktype: 2,
	          vcnt: "",
	          clen: ""
	      };
	      data.htype = 6362;
	      data.aid = String(this.initParam.aId);
	      data.uid = this.initParam.uid;
	      data = JSON.stringify(data);
	      len = data.length;
	      data = encodeURIComponent(crypt.encrypt(data));
	      sendData.vcnt = data;
	      sendData.clen = len;
	      var sendData = JSON.stringify(sendData);
	      socket.send(sendData);
	    },
	    //默认图片
	    defaultPic(e){
	      this.$common.defaultPic(e);
	    },
	    //等级图片
	    levImg(lev,type){
	    	if(lev>7&&type!=5&&type!=6){
	    		lev=7;
	    	}
	    	//用户等级
	    	if(type==1){
	    		return require('../assets/images/levImg/level'+lev+'.png');
	    	}else if(type==2){//主播等级
	    		return require('../assets/images/levImg/zlevel'+lev+'.png');
	    	}else if(type==3){//贵族等级
	    		return require('../assets/images/levImg/guizu'+lev+'.png');
	    	}else if(type==4){//点赞
	    		return require('../assets/images/'+(lev-1)+'.png');
	    	}else if(type==5){
	    		return require('../assets/images/prize/num_'+lev+'.png');
	    	}else if(type==6){//刷礼数量
	    		return require('../assets/images/num'+lev+'.png');
	    	}
	    },
	    getMcInfo_num(){
	    	var time=parseInt(new Date().getTime()/1000);
	    	var fansData={
				user_id: this.userInfo.user_id,
				to_user_id: this.mcInfo.id,
				isJump: 1,
				token: this.$store.state.loginUserInfo.token,
				sign: this.$md5(this.userInfo.user_id + 'get_fans_nums' + this.$store.state.loginUserInfo.token + time),
				time: time
			}
			//主播粉丝数量
			this.axios({url:'https://external.fengbolive.com/cgi-bin/get_fans_nums.fcgi?'+this.$common.changeobj(fansData),adapter: jsonpAdapter}).then(response=>{
				if(response.data.ret==0){
					this.mcInfo_num.fans_num=response.data.con;
				}
			})
			var focusData={
				user_id: this.userInfo.user_id,
				to_user_id: this.mcInfo.id,
				isJump: 1,
				token: this.$store.state.loginUserInfo.token,
				sign: this.$md5(this.userInfo.user_id + 'get_focus_on_nums' + this.$store.state.loginUserInfo.token + time),
				time: time
			}
			//主播关注数量
			this.axios({url:'https://external.fengbolive.com/cgi-bin/get_focus_on_nums.fcgi?'+this.$common.changeobj(focusData),adapter: jsonpAdapter}).then(res=>{
				res=res.data;
				if(res.ret==0){
					this.mcInfo_num.follow_num=res.con;
				}
			})
			var followData={
				a : this.userInfo.user_id,
				b : this.mcInfo.id,
				token : this.$store.state.loginUserInfo.token,
				version : this.$store.state.loginUserInfo.version,
				isJump : '1',
				reg_mac : localStorage.getItem('mac'),
				pid : this.$store.state.loginUserInfo.pid,
				timestamp : time,
				sign : this.$md5(this.userInfo.user_id + 'is_follow' + this.mcInfo.id + this.$store.state.loginUserInfo.version + time + this.$store.state.loginUserInfo.token + localStorage.getItem('mac'))
			};
			//是否关注主播
			this.axios({
				url:'https://external.fengbolive.com/cgi-bin/is_follow.fcgi?'+this.$common.changeobj(followData),
				adapter: jsonpAdapter
			}).then(res=>{
				if(res.data.ret==0){
					if(res.data.con==1){//关注
						this.mcInfo_num.isFollow=true;
					}else{//未关注
						this.mcInfo_num.isFollow=false;
					}
				}
			})
			var uData={
				user_id:this.userInfo.user_id,
				logintype:localStorage.getItem('loginType'),
				reg_mac:localStorage.getItem('mac'),
				token:this.$store.state.loginUserInfo.token
			}
	        this.axios({
	            url:location.protocol+'//api.fengbolive.com/userinfo/getuserinfo/virtual.html?'+this.$common.changeobj(uData),
	            adapter: jsonpAdapter
	        }).then(res=>{
	        	res=res.data;
	        	this.mcInfo_num.u=res.data;
	        })
	    },
	    userExit(){
	    	this.$common.delCookie('userInfo');
            //this.$common.delCookie('FENGBO','/','.fengbolive.com');
            //this.$common.delCookie('FENGBOZHIBO','/','.fengbolive.com');
            //this.$common.delCookie('FENGBO','/','.live.sinashow.com');
            //this.$common.delCookie('FENGBOZHIBO','/','.live.sinashow.com');
            this.$parent.visiterLogin();
	    },
	    // 观众列表
	    userListBloodshed : function(backData){
	        var backArr = backData.ulist;
	        if(this.userList.length == 0){
	            this.userList=backArr;
	        }else{
	            for(var k = 0 ; k < backArr.length ; k++){
	                for(var z= 0; z < this.userList.length ; z ++){
	                    if(backArr[k]&&backArr[k]['uid'] == this.userList[z]['uid']){
	                        backArr.splice(k , 1);
	                    }
	                }
	            }
	        }
	        this.userList=this.userList.concat(backArr);
	        this.showUserList();
	    },
	    showUserList : function(uid) {
	        if(this.userList.length > 200){
	            return;
	        }
	        var compareArr = this.userList.sort(this.compare('skey','uid'));  //排序完成之后的数组！
	        var user_list = null;
	        for(var i = 0 ; i<compareArr.length ; i++){
	        	if(user_list){
		            if(compareArr[i].uid == user_list.uid){
		            	compareArr.splice(i , 1); 
	                	i--;
		                continue;
		            }
	        	}
	            if(compareArr[i].uid == uid){
	                compareArr.splice(i , 1); 
	                i--;
	                continue;
	            }
	            if(compareArr[i].uid == this.mcInfo.id){
	            	compareArr.splice(i , 1); 
	                i--;
	                continue;
	            }
	            //管理员
	            if(compareArr[i].manage){
	                var stop=false;
	                for(var j=0;j<compareArr[i].manage.length;j++){
	                    if(compareArr[i].manage[j].miLevel==240||compareArr[i].manage[j].miLevel==230||compareArr[i].manage[j].miLevel==220){
	                        stop=true;
	                        break;
	                    }
	                }
	                if(stop){
	                	compareArr.splice(i , 1); 
	                	i--;
	                    continue;
	                }
	            }
	            //机器人
	            if( compareArr[i].robot){
	            	var img='';
	                if(compareArr[i].sex == 0){
	                    img = compareArr[i].uid%7133;
	                }
	                else if (compareArr[i].sex == 1){
	                    img = compareArr[i].uid%4223;
	                }
	                compareArr[i].photoPic=' https://img.fengbolive.com/pic/rebot/'+compareArr[i].sex+"/"+img+'.jpg';
	            }else{
	                //游客
	                if( compareArr[i].pnum === 0 || compareArr[i].pnum === 1){
	                    compareArr[i].photoPic=location.protocol+'//img.fengbolive.com/pic/avatar/default.png';
	                }else{//正常用户
	                	compareArr[i].photoPic=this.$common.getPhotoUrl(compareArr[i].uid,compareArr[i].pnum,2)
	                }
	            }
				if(compareArr[i].identity){
	                for(var j=0;j<compareArr[i].identity.length;j++){
	                    if(compareArr[i].identity[j].miType==9){
	                    	if(compareArr[i].guizuLev){continue}
	                    	compareArr[i].guizuLev=parseInt(compareArr[i].identity[j].miLevel)/10;
	                    }else if(compareArr[i].identity[j].mitype==9){
	                        if(compareArr[i].guizuLev){continue}
	                        compareArr[i].guizuLev=parseInt(compareArr[i].identity[j].milevel)/10;
	                    }
	                    if(compareArr[i].identity[j].mitype==61||compareArr[i].identity[j].mitype==63||compareArr[i].identity[j].miType==61||compareArr[i].identity[j].miType==63){
			                compareArr[i].lh=true;
			            }
			            if(compareArr[i].identity[j].mitype==62||compareArr[i].identity[j].miType==62){
			            	compareArr[i].sale=true;
			            }
	                }
	            }
	            user_list = compareArr[i];
	        }
	        this.newUserList = compareArr;
	    },
	     //用户列表的排序规则
	    compare : function(prop,uid){
	        return function(obj1 , obj2){
	            var v_1 = obj1[prop],
	                v_2 = obj2[prop];
	            var c = obj1[uid],d = obj2[uid];
	            if(v_1 < v_2){
	                return -1;
	            }else if(v_1 > v_2){
	                return 1;
	            }else{
	                if(c < d){
	                    return -1;
	                }else if(c > d){
	                    return 1;
	                }
	                return  0;
	            }
	        }
	    },
	    //用户列表滚动
	    userScroll(e){
	    	var scrollTop=e.target.scrollTop;
	    	var maxHeight=parseInt(getComputedStyle(document.getElementById('userScroll')).height);
	    	var containerHeight=parseInt(getComputedStyle(document.getElementById('userList')).height);
	    	if(scrollTop+containerHeight+5>=maxHeight){
	    		if(this.userScrollLock){
	    			return
	    		}
	    		this.userListPage++;
	    		this.userScrollLock=true;
	    		var that=this;
            	var page = {};
		        page.rid = Number(that.initParam.rid) ;
		        page.htype = 6355;
                page.pagenum = Number(this.userListPage);
                var pageJson = JSON.stringify(page);
                var pageEncrypt = crypt.encrypt( pageJson);
                var clen = pageEncrypt.length;
                var sendPage = {
                    ktype : Number(2),
                    clen : clen ,
                    vcnt : pageEncrypt
                };
                var sendPageJSON = JSON.stringify(sendPage);
                socket.send(sendPageJSON);
                setTimeout(function(){
                	that.userScrollLock=false;
                },1000)
	    	}
	    },
	    //点赞
	    thumbsUpAnimate(send){
	    	if(send){
	    		var msg={
	    			htype:5645,
	    			uid:parseInt(this.userInfo.user_id)
	    		}
	    		var chatAllData = {};
                var jsonData = JSON.stringify(msg);
                //加密之后的数据
                var encryptData = encodeURIComponent(crypt.encrypt(jsonData));
                var clen = encryptData.length;
                chatAllData.ktype = 2;
                chatAllData.vcnt = encryptData;
                chatAllData.clen = clen;
                var chatAllDataString = JSON.stringify(chatAllData);
                socket.send(chatAllDataString);
	    	}else{
	    		var random=Math.ceil(Math.random(0,1)*4);
	    		this.fabulousList.push(random);
	    	}
	    },
	    danTab(index){
	    	this.chatType=index;
	    },
	    chatMsgsend(){
	    	if(this.chatMsg==''){
	        	return
	        }
	        if(this.quite){
	    		return
	    	}
			var time = parseInt(new Date().getTime()/1000);
			this.axios({
				method:'post',
				url:location.protocol + '//api.aoruizhu.com/messagecheck/index',
				data:this.$common.changeobj({user_id:this.userInfo.user_id,time,content:this.chatMsg,sign:this.$md5(time+'58d4622ec66923beac25e5ebebdd8a19')})
			}).then(res=>{
				if(res.data.code==1){
					var chat={
						control:'',
					    mood :encodeURIComponent('%1对%2说:'),
					    destUid     : "0", //公共信息标识 String
					    srcUid   :  this.userInfo.user_id,//来源用户id String
					    htype : 6323,
					    srcName : this.userInfo.nick_nm,   //用户昵称          string
					    srcPhoto : this.loginData.pnum, //头像索引          Number
					    srcPl1 : this.loginData.pl1,   //大等级            Number
					    srcPl2 : this.loginData.pl2,   //小等级            Number
					    chatmsg : String(this.chatMsg),     //消息 String
					    lnobility:parseInt(this.loginData.guizu)*10
					}
					if(this.loginData.lh){
						chat.identity=5;
					}
					if(this.chatDan){
						var price=0;
						var type=0;
						if(this.chatType==1){
							price=2000;
							type=80;
						}else if(this.chatType==2){
							price=50000;
							type=82;
						}else{
							price=100000;
							type=83;
						}
						if(this.chatMsg.length>20){
							this.$store.dispatch('upDataWindowBoxShowBool',{msg:'文字字数超出限制，弹幕内容20字，普通聊天内容140字'});
							return
						}
						if(this.mcInfo_num.u<price){
							this.$store.dispatch('upDataWindowBoxShowBool',{msg:'余额不足请充值！', type:2});
							return 
						}
					    chat.type = type;   
					    chat.lnobility =this.loginData.lnobility;
					    var chatAllData = {};
					    var jsonData = JSON.stringify(chat);
					    //加密之后的数据
					    var encryptData = encodeURIComponent(crypt.encrypt(jsonData));
					    var clen = encryptData.length;
					    chatAllData.ktype = 2;
					    chatAllData.vcnt = encryptData;
					    chatAllData.clen = clen;
					    var chatAllDataString = JSON.stringify(chatAllData);
					    socket.send(chatAllDataString);
					    var obj={
					        srcPl1:this.loginData.pl1,
					        srcPl2:this.loginData.pl2,
					        guizu:this.loginData.guizu,
					        lh:this.loginData.lh,
					        srcName:decodeURIComponent(this.userInfo.nick_nm),
					        chatmsg:this.chatMsg
						};
						
						obj.msgType = 1;
					    this.chatMsgList.push(obj);
					}else{
					    chat.type = 0;
					    /**添加新的协议数据**/
					    chat.showState = this.loginData.showState; //登陆返回包中存在  Number
					    //聊天信息
					    var chatAllData = {};
					    var jsonData = JSON.stringify(chat);
					    //加密之后的数据
					    var encryptData = encodeURIComponent(crypt.encrypt(jsonData));
					    var clen = encryptData.length;
					    chatAllData.ktype = 2;
					    chatAllData.vcnt = encryptData;
					    chatAllData.clen = clen;
					    var chatAllDataString = JSON.stringify(chatAllData);
					    socket.send(chatAllDataString);
					    //srcPl1 srcPl2 lnobility identity srcName chatmsg
					    var obj={
					        srcPl1:this.loginData.pl1,
					        srcPl2:this.loginData.pl2,
					        guizu:this.loginData.guizu,
					        lh:this.loginData.lh,
					        srcName:decodeURIComponent(this.userInfo.nick_nm),
					        chatmsg:this.chatMsg
						};
						obj.msgType = 1;
					    this.chatMsgList.push(obj);
					}
					this.chatMsg='';
					var that=this;
					that.chatBar.setSize();
					setTimeout(function(){
						that.chatBar.jump({pos:'bottom',time:300});
					},300)
				}else{
					this.$store.dispatch('upDataWindowBoxShowBool',{msg:'输入词汇含敏感词，请检查后再重新发送！'});
				}
			})
	        
		},
		// 赠送礼物
	    giftSend(){
			//this.$refs.video.playVideoGift('http://localhost:8080/kun.mp4');
	    	if(this.quite){
	    		return
	    	}
	    	if(!this.userInfo.photo_num){
	    		this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请登录后再进行操作~',type:4});
	    		return
	    	}
			let gitCount = this.giftCount;
			var gift=null;
			if(this.moreGift){
				for(var i=0;i<this.giftList.length;i++){
					if(this.giftList[i].active){
						gift=this.giftList[i];
					}
				}
			}else{
				for(var i=0;i<this.showGiftList.length;i++){
					if(this.showGiftList[i].active){
						gift=this.showGiftList[i];
					}
				}
			}
			if(!gift){
				return
			}
			let giftPrice = gift.gift_price;
			if (gitCount*giftPrice > this.mcInfo_num.u) {
	            this.$store.dispatch('upDataWindowBoxShowBool',{msg:'余额不足请充值！', type:2});
				return
			}
			let jsonObj = {
				'htype': 6303,
				'ret': 0,
				'uid': '' + this.userInfo.user_id, //用户 ID
				'dstuid': '' + this.giftId, //目标用户 ID
				'propid': parseInt(gift.gift_id), //道具 ID
				'propname': gift.gift_name, //道具名称
				'ucnt': gitCount, //使用数量
				'upacket': 0, //是否使用背包
				'userName': this.userInfo.nick_nm, //用户昵称
				'phoneNum': this.loginData.pnum, //用户头像
				'propImg': gift.gift_image, //礼物头像
			};
	        var giftAllData = {};
            var jsonData = JSON.stringify(jsonObj);
            //加密之后的数据
            var encryptData = encodeURIComponent(crypt.encrypt(jsonData));
            var clen = encryptData.length;
            giftAllData.ktype = 2;
            giftAllData.vcnt = encryptData;
            giftAllData.clen = clen;
            var giftAllDataString = JSON.stringify(giftAllData);
            socket.send(giftAllDataString);
	    },
		getSign(user_id, version, time, token, page, reg_mac, key) {
			let t = "{0}{1}{2}{3}{4}{5}{6}";
			return crypt.getMD5(t.format(user_id, version, time, token, page, reg_mac, key));
		},
	    getHotList(iPage){
			let nowtimeStamp = new Date().getTime();
			let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.$store.state.loginUserInfo.token, iPage, localStorage.getItem('mac'), 'get_hot_list_h5');
			var data = {
				page:iPage,
				qid: 50000,
				reg_mac: localStorage.getItem('mac'),
				sign:sign,
				token: this.$store.state.loginUserInfo.token,
				user_id: this.userInfo.user_id,
				ver: this.$store.state.loginUserInfo.version,
				time: nowtimeStamp,        
				pid: this.$store.state.loginUserInfo.pid,
				uid: this.userInfo.user_id,
				version: this.$store.state.loginUserInfo.version,
				source:'live',
				type:'0'
			};
			let that = this;
			this.axios({
				url:"https://external.fengbolive.com/cgi-bin/get_hot_list_h5.fcgi?" + this.$common.changeobj(data),
				adapter: jsonpAdapter,
				}).then(res=>{
					let data = res.data;
					if(data.info&&data.info.length==6){
						this.getHotList(iPage+1);
					}
					if (data.code > 0 || data.ret > 0) {
						var list=data.info;
						for(var i=0;i<list.length;i++){
							if(list[i].id==this.mcInfo.id){
								list.splice(i,1);
								i--;
								continue;
							}
							list[i].img=this.$common.getPhotoUrl(list[i].id,list[i].phid,2);
						}
						this.hotList=this.hotList.concat(list);
					}
				})
		},
		onClickAnchorFinnish(id, familyId){
			// let strPath = "/live/"+id;
			// let param = { path: strPath };
			// this.$router.push(param);
			//this.$router.go(0);
            localStorage.setItem('AnchorId','' + id);
            localStorage.setItem('FamilyId','' + familyId);
			this.toLive(id);
		},
		toLive(id){
			let strPath = "/live/"+id;
			let param = { path: strPath };
			this.$router.push(param);
			//this.$router.go(0);
		},
		getCardDetail(data,e){
			if(data.manage){
				for(var i=0;i<data.manage.length;i++){
					if(data.manage[i].miType==5&&data.manage[i].miLevel==80){
						data.fangguan=true;
						break;
					}
				}
			}
			this.cardDetail=data;
			this.cardDetail.top=e.pageY;
			if(!data.robot&&data.pnum!=0&&data.pnum!=1){
				this.axios({
					url:location.protocol + "//api.fengbolive.com/userinfo/getinfo.html?"+this.$common.changeobj({
						uid: data.uid,
						user_id: this.userInfo.user_id,
						reg_mac: localStorage.getItem('mac'),
						token: this.$store.state.loginUserInfo.token,
						ver: this.$store.state.loginUserInfo.version,
						pid: this.$store.state.loginUserInfo.pid
					}),
					adapter: jsonpAdapter
				}).then(res=>{
					res=res.data;
					this.cardDetail.sex=res.data.user_sex;
				})
			}
			if(data.pnum!=0&&data.pnum!=1&&this.userInfo.photo_num){
				var obj = {};
				var nowtimeStamp=parseInt(new Date().getTime() / 1000);
				obj.a = this.userInfo.user_id;
				obj.b = data.uid;
				obj.token = this.$store.state.loginUserInfo.token;
				obj.version = this.$store.state.loginUserInfo.version;
				obj.isJump = '1';
				obj.reg_mac = localStorage.getItem('mac');
				obj.pid = this.$store.state.loginUserInfo.pid;
				obj.timestamp = nowtimeStamp;
				obj.sign = this.$md5(obj.a + 'is_follow' + data.uid + obj.version + nowtimeStamp + obj.token + obj.reg_mac);
				this.axios({
					url:'https://external.fengbolive.com/cgi-bin/is_follow.fcgi?'+this.$common.changeobj(obj),
					adapter: jsonpAdapter
				}).then(res=>{
					res=res.data;
					if(res.ret==0){
						if(res.con==1){
							this.cardDetail.care=true;
						}else{
							this.cardDetail.care=false;
						}
					}
				})
			}
		},
		closeCard(){
			this.cardDetail=null;
		},
		careSomeone(){
			if(!this.userInfo.photo_num){
				this.$store.dispatch('upDataWindowBoxShowBool',{msg:'登录后才可以关注呦~',type:4});
				return
			}
			if(this.cardDetail.pnum==0||this.cardDetail.pnum==1){
				this.$store.dispatch('upDataWindowBoxShowBool',{msg:'不可以关注游客呦~'});
				return
			}
			if(this.cardDetail.uid==this.userInfo.user_id){
				return
			}
			var time=parseInt(new Date().getTime() / 1000);
			var data={
				'isJump': 1,
				'type': this.cardDetail.care?'c':'f',
				'user_id': this.userInfo.user_id,
				'uid': this.cardDetail.uid,
				'token': this.$store.state.loginUserInfo.token,
				'version': this.$store.state.loginUserInfo.version,
				'reg_mac': localStorage.getItem('mac'),
				'pid': this.$store.state.loginUserInfo.pid,
				'timestamp': time
			};
			data.sign = this.$md5(this.userInfo.user_id + 'add_follow' + this.cardDetail.uid + this.$store.state.loginUserInfo.version + this.$store.state.loginUserInfo.token + localStorage.getItem('mac') + time);
			this.axios({
				url:'https://external.fengbolive.com/cgi-bin/add_follow.fcgi?'+this.$common.changeobj(data),
				adapter: jsonpAdapter
			}).then(res=>{
				res=res.data;
				if(res.ret==0){
					this.cardDetail.care=!this.cardDetail.care;
					this.$forceUpdate();
				}else{
					this.$store.dispatch('upDataWindowBoxShowBool',{msg:'关注失败~'});
				}
			})
		},
		toGift(){
			if(this.cardDetail.uid==this.userInfo.user_id){
				return
			}
			for(var i=0;i<this.sendUserList.length;i++){
				if(this.sendUserList[i].id==this.cardDetail.uid){
					this.closeCard();
					return
				}
			}
			this.sendUserList.push({name:this.cardDetail.name,id:this.cardDetail.uid});
			this.giftId=this.cardDetail.uid;
			this.closeCard();
		},
		openChatDan(){
			this.chatDan=!this.chatDan;
		},
		addU(){
			// if(this.userInfo.photo_num){
			// 	var str='reg_mac='+localStorage.getItem('mac')+'&nick_nm='+encodeURIComponent(this.userInfo.nick_nm)+'&token='+this.$store.state.loginUserInfo.token+'&user_id='+this.userInfo.user_id;
            //     window.open('http://pay.live.sinashow.com/userinfo/site/webpc.html?'+str);
            // }else{
            //     window.open('http://pay.live.sinashow.com/userinfo/site/webpc.html');
            // }
			window.open('/pay');
		},
		closeRemind(){
			this.bShowChargeRemind = false;
		},
		scoreComputed(){
			var that=this;
			if(that.pkData.blueScore==that.pkData.redScore){
				that.bluePercent=50;
				that.redPercent=50;
			}else{
				var sum=Number(that.pkData.blueScore)+Number(that.pkData.redScore);
				var blue=parseInt((that.pkData.blueScore/sum)*100);
				blue=blue>99?99:blue;
				blue=blue<1?1:blue;
				that.pkData.bluePercent=blue;
				that.pkData.redPercent=100-blue;
			}
		}
	},
	computed:{
		userInfo(){
            if(this.$store.state.loginUserInfo.info){
                return this.$store.state.loginUserInfo.info;
            }else if(sessionStorage.getItem('userInfo')){
                return JSON.parse(sessionStorage.getItem('userInfo'));
            }else{
				return {
					nick_nm:'游客912067379',
					user_id:'912067379'
				}
			}
        },
        mcInfo(){
        	if(this.$store.state.chatRoomInfo.currentAnchorInfo){
        		return this.$store.state.chatRoomInfo.currentAnchorInfo;
        	}
        },
        //用户头像
        imgsrc(){
            if(this.userInfo&&this.userInfo.photo_num){
                return this.$common.getPhotoUrl(this.userInfo.user_id,this.userInfo.photo_num,2);
            }else{
                return '';
            }   
		},
		Pid(){
			return this.$store.state.loginUserInfo.pid;
		}
	},
	watch:{
		userInfo(newValue,oldValue){
			if(loginremindtimer){
				cleartimeout(loginremindtimer);
				loginremindtimer = null
			}

			if(newValue.photo_num){
				this.getMcInfo_num();
			}else{
				this.mcInfo_num.u=0;
			}

			if(socket){
				socket.quite();
				offline=false;
				this.userList=[];
				this.openSocket();
			}
		},
		moreGift(n,o){
        	if(!n){
        		this.giftSize();
        	}
        }
	},
	beforeRouteUpdate (to, from, next) {
		this.previewAnchorId=Number(localStorage.getItem('AnchorId'));
		this.familyId=Number(localStorage.getItem('FamilyId'));
		socket.quite();
		this.close=false;
		this.chatMsgList=[];
		this.userList=[];
		this.inRoomList=[];
		this.sendUserList=[];
		this.hotList=[];
		//this.getHotList(1);
		this.inRoomBar.setSize();
		this.chatBar.setSize();
		if(websocketTimer){
			clearTimeout(websocketTimer);
		}
		next(true);
		// 在当前路由改变，但是该组件被复用时调用
		// 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
		// 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
		// 可以访问组件实例 `this`
	},
	beforeRouteLeave  (to, from, next) {
	    clearInterval(timer);
	    offline=false;
		window.onresize=null;
		if(websocketTimer){
			clearTimeout(websocketTimer);
		}
		
		// if(loginRemindTimer){
		// 	clearTimeout(loginRemindTimer);
		// 	loginRemindTimer = null
		// }
		
	    document.getElementById('livePage').onclick=null;
	    if(socket){
			socket.quite();
	    }
		next(true)
	}
};
</script>